"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UwEventNames = void 0;
var _ = require("lodash");
exports.UwEventNames = {
    ACCELERATED_OFFER_READY: {
        name: 'AcceleratedOfferReady'
    },
    LITETOUCH_OFFER_READY: {
        name: 'LiteTouchOfferReady'
    },
    LITETOUCH_DECLINED: {
        name: 'LiteTouchDeclined'
    },
    REQUIRE_REFLEXIVE_DATA: {
        name: 'RequireReflexiveData'
    },
    INSURED_ID_VERIFIED: {
        name: 'InsuredIdVerified'
    },
    INSURED_ID_VERIFIED_NOT_BORN_IN_US: {
        name: 'InsuredIdVerifiedNotBornInUS'
    },
    OWNER_ID_VERIFIED_OR_SKIPPED: {
        name: 'OwnerIdVerifiedOrSkipped'
    },
    OWNER_ID_VERIFIED_NOT_BORN_IN_US: {
        name: 'OwnerIdVerifiedNotBornInUS'
    },
    INSURED_ID_VERIFICATION_FAILED: {
        name: 'InsuredIdVerificationFailed'
    },
    OWNER_ID_VERIFICATION_FAILED: {
        name: 'OwnerIdVerificationFailed'
    },
    INSURED_AND_OWNER_ID_VERIFICATION_FAILED: {
        name: 'InsuredAndOwnerIdVerificationFailed'
    },
    NON_TLIC_APPLICATION_READY: {
        name: 'NonTlicApplicationReady'
    },
    TLIC_OFFER_READY: {
        name: 'TlicOfferReady'
    },
    MVR_FAILED: {
        name: 'MvrFailed'
    },
    OPS_SUPPORT_TICKET_OPENED: {
        name: 'OpsSupportTicketOpened'
    },
    OPS_SUPPORT_TICKET_UW_COMMENT: {
        name: 'OpsSupportTicketUwComment'
    },
    CUSTOMER_FOLLOW_UP_OPENED: {
        name: 'CustomerFollowUpOpen'
    },
    INSURED_ID_FAILED_IN_ALGO: {
        name: 'InsuredIdFailedInAlgo'
    },
    OWNER_ID_FAILED_IN_ALGO: {
        name: 'OwnerIdFailedInAlgo'
    },
    FINAL_ALGO_OFFER_READY: {
        name: 'FinalAlgoOfferReady'
    },
    FINAL_MANUAL_OFFER_READY: {
        name: 'FinalManualOfferReady'
    },
    PARAMED_REQUEST_SENT: {
        name: 'ParamedRequestSent'
    },
    EXAM_VENDOR_FETCHED: {
        name: 'ExamVendorFetched'
    },
    PARAMED_NOT_REQUIRED: {
        name: 'ParamedNotRequired'
    },
    PARAMED_SCHEDULED: {
        name: 'ParamedScheduled'
    },
    RECEIVED_LAB_RESULTS: {
        name: 'ReceivedLabResults'
    },
    INSURED_OFAC_HIT: {
        name: 'InsuredOfacHit'
    },
    OWNER_OFAC_HIT: {
        name: 'OwnerOfacHit'
    },
    INSURED_AND_OWNER_OFAC_HIT: {
        name: 'InsuredAndOwnerOfacHit'
    },
    CANCEL_OUT_OF_TIME_UNDERWRITING: {
        name: 'CancelOutOfTimeUnderwriting'
    },
    POLICY_REJECTED_HAVEN: {
        name: 'PolicyRejectedWithHavenOption'
    },
    POLICY_REJECTED_VANTAGE: {
        name: 'PolicyRejectedWithVantageOption'
    },
    POLICY_REJECTED: {
        name: 'PolicyRejected'
    },
    POLICY_DECLINED_VANTAGE: {
        name: 'PolicyDeclinedWithVantageOption'
    },
    POLICY_DECLINED: {
        name: 'PolicyDeclined'
    },
    ENTERED_MANUAL_UNDERWRITING: {
        name: 'EnteredManualUnderwriting'
    },
    APS_RECEIVED_AFTER_CLOSE: {
        name: 'EmailUwSupportApsReceivedAfterClose'
    },
    APS_ACTION_REQUIRED: {
        name: 'EmailOpsApsActionRequired'
    },
    POLICY_MANUAL_REVIEW: {
        name: 'PolicyManualReview'
    },
    TEMPORARY_HOLD: {
        name: 'TemporaryHold'
    },
    SMOKER_INDICATED_BY_THIRD_PARTY: {
        name: 'SmokerIndicatedByThirdParty'
    },
    SCHEDULING_REQUIRED: {
        name: 'SchedulingRequired'
    },
    SCHEDULING_NOT_REQUIRED: {
        name: 'SchedulingNotRequired'
    },
    find: function (name) {
        var matcher = {
            name: name
        };
        return this._findMatch(matcher);
    },
    _findMatch: function (matcher) {
        return _.find(_.values(this), matcher);
    }
};
//# sourceMappingURL=UwEventName.js.map